import React from "react";
import { DialogContainer } from "react-md";
import FontIcon from "react-md/lib/FontIcons";

/**
 * "Order rejected!" success dialog shown after a successful POST /reject.
 *
 *  - Reorder → onReorder(): clones this rejected cart into a fresh DRAFT and
 *    opens it as a newly created cart (EDIT-DRAFT) with details pre-filled.
 *  - Done → onDone() (typically exits to the dashboard which then refreshes).
 *
 * Mirrors MarkOnHoldSuccessDialog but with a red X icon and a teal Reorder
 * CTA instead of the green check / Resume order pairing.
 */
const RejectOrderSuccessDialog = ({ visible, onReorder, onDone }) => {
  return (
    <DialogContainer
      id="cart-reject-order-success-dialog"
      visible={visible}
      onHide={onDone}
      focusOnMount={false}
      width={"560px"}
      autosizeContent={true}
      dialogStyle={{ borderRadius: "10px" }}
      modal
    >
      <div className="mhsd-container">
        <div className="mhsd-icon">
          <div className="mhsd-icon-outer mhsd-icon-outer--reject">
            <div className="mhsd-icon-inner mhsd-icon-inner--reject">
              <FontIcon style={{ fontSize: "44px", color: "#fff" }}>
                close
              </FontIcon>
            </div>
          </div>
        </div>
        <h2 className="mhsd-title">Order rejected!</h2>

        <div className="mhsd-footer">
          <button
            type="button"
            className="mhsd-btn mhsd-btn--resume"
            onClick={() => {
              if (onReorder) onReorder();
            }}
          >
            Reorder
          </button>
          <button
            type="button"
            className="mhsd-btn mhsd-btn--done"
            onClick={onDone}
          >
            Done
          </button>
        </div>
      </div>
    </DialogContainer>
  );
};

export default RejectOrderSuccessDialog;
